var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 347,
    height: 441,
    viewBox: "0 0 347 441",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.68,
    filter: "url(#filter0_f_53_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.478 99L171.851 104.529V264.977L173.478 266.601L247.956 222.577L173.478 99Z",
    fill: "#BF125D",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.478 99L99 222.577L173.478 266.602V188.725V99Z",
    fill: "#BF125D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.477 280.703L172.561 281.821V338.976L173.477 341.654L248 236.701L173.477 280.703Z",
    fill: "#8F0340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.478 341.653V280.702L99 236.7L173.478 341.653Z",
    fill: "#BF125D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.478 266.601L247.955 222.578L173.478 188.725V266.601Z",
    fill: "#D83E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0007 222.578L173.478 266.601V188.726L99.0007 222.578Z",
    fill: "#96114A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.478 99L171.851 104.529V264.977L173.478 266.601L247.956 222.577L173.478 99Z",
    fill: "#BF125D",
    fillOpacity: 0.77
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.478 99L99 222.577L173.478 266.602V188.725V99Z",
    fill: "#BF125D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.477 280.703L172.561 281.821V338.976L173.477 341.654L248 236.701L173.477 280.703Z",
    fill: "#8F0340"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.478 341.653V280.702L99 236.7L173.478 341.653Z",
    fill: "#BF125D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.478 266.601L247.955 222.578L173.478 188.725V266.601Z",
    fill: "#D83E81"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0007 222.578L173.478 266.601V188.726L99.0007 222.578Z",
    fill: "#96114A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_53_17",
    x: 0.400002,
    y: 0.400002,
    width: 346.2,
    height: 439.854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.3,
    result: "effect1_foregroundBlur_53_17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.b3b64ae1a250c116ff5ccd95c4f9351d.svg";
export { ForwardRef as ReactComponent };